import BaseModelAPI from '../BaseModelAPI';

export default class StockOpnamePlan extends BaseModelAPI {
	static entity = 'stockopnameplan';
	static entityName = 'stockopnameplan';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.name = '';
			this.startStockOpnamePeriod = '';
			this.finishStockOpnamePeriod = '';
			this.stockOpnameStatusId = '';
			this.stockOpnameStatus = {};
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}